export default __webpack_public_path__ + "static/media/downloadLaw.01ff9fa0.svg";